<template>
	<div class="el-textarea-wrapper" :class="{ 'can-change': can_edit, 'has-max-length': maxLength}" :style="{'display': inline ? 'inline' : undefined}">
		<div v-if="parent_data" class="element el-textarea" :style="{ 'max-width': width,'height':height, 'display': inline ? 'inline' : undefined}" :class="{ 'can-change': can_edit, error: size > maxLength && maxLength }">
			<div :style="{'display': can_edit ? undefined : 'inline'}" :class="{'inline-block': can_edit, 'full-width full-height': can_edit && !inline}">
				<span v-show="!can_edit && placeholder && is_empty" class="inline-placeholder">{{ placeholder }}</span>
				<span v-show="can_edit && placeholder && is_empty" class="placeholder">{{ placeholder }}</span>
				<p v-if="can_edit" class="input" :class="{ 'editable': can_edit, 'full-height': can_edit && !inline }" :style="{ 'overflow': overflow_edit, 'display': inline ? 'inline' : undefined}" ref="textarea" @input="input_change" :contenteditable="can_edit ? 'plaintext-only' : false"  @change="test($even)" @keyup="set_empty()" @blur="change($event)" v-html="value" @focus="selectAll" @keydown.enter="onKeyEnter($event)"></p>
				<p v-else-if="display_value" v-html="display_value+' '+suffix" contenteditable="false" :style="{'display': inline ? 'inline' : undefined}" class="display-area" :class="{'align-justify' : text_align == 'justify'}"></p>
			</div>
		</div>
		<div v-if="can_edit && maxLength" :style="{'display': inline ? 'inline' : undefined}" class="counter">
			<span v-if="maxLength">{{size}}/{{maxLength}} caractères</span>
			<span v-if="size > maxLength">Attention! Votre texte sera tronqué</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ElementMixin from "@/components/study/editor/elements/element.mixin.js";
import number from "@/libs/number";

export default {
	name: "el-textarea",
	mixins: [ ElementMixin ],
	data: function () {
		return {
			is_empty: true,
			lastValue: "",
			size: "0"
		};
	},
	props: {
		placeholder: { default: "" },
		width: { default: "100%" },
		format: { default: "string" },
		selectAllOnFocus: { default: false },
		money_parse: { type: Boolean, default: false },
		suffix: { type: String, default: ""},
		allow_edit: { type: Boolean, default: true},
		component: {default: undefined},
		maxLength: {default: 0, type: Number},
		height: { default: "auto" },
		overflow_edit: { default: "auto" },
		submit_on_enter_key: { default: false, type: Boolean },
		inline: { type: Boolean, default: false },
		restrict_input: { type: String, default: undefined },
		text_align: { type: String, required: false }
	},
	computed: {
		...mapGetters([ ]),
		can_edit: function (){
			return this.is_editable && this.allow_edit;
		},
		display_value: function () {
			if (this.format != "number") {
				if(this.money_parse){
					return this.moneyParse(this.value);
				}
				return this.value;
			}
			if (typeof (this.value) == "number" && isNaN(this.value)) {
				return "-";
			}
			if (!number.is_number(this.value)) {
				return this.value;
			}
			if (!isNaN(parseFloat(this.value))) {
				const result = this.round_100(this.value, 1);
				if(this.money_parse){
					return moneyParse(result);
				}
				return result;
			}
			if(this.money_parse){
				return moneyParse(this.value);
			}
			return this.value;
		}
	},
	methods: {
		selectAll (event) {
			if (!this.selectAllOnFocus) {
				return;
			}
			setTimeout(function () {
				const range = document.createRange();
				range.selectNodeContents(event.target);
				const sel = window.getSelection();
				sel.removeAllRanges();
				sel.addRange(range);
			}, 100);
		},
		set_empty: function () {
			const text = this.$refs.textarea.innerHTML;
			this.is_empty = (text == "");
		},
		change: function (e) {
			if (this.can_edit/*  && e.target.innerHTML <= this.maxLength */){
				if(this.maxLength && e.target.textContent.length > this.maxLength)
					e.target.textContent = e.target.textContent.slice(0, this.maxLength);
				if(this.component)
					this.$emit("changed_value", e.target.innerHTML);
				else
					this.edit_study(e.target.innerHTML);
				this.size = e.target.textContent.length;
				this.$forceUpdate();
			}
		},
		input_change: function (e){
			if(this.restrict_input === "number" && !(/^(\s*|\d+)$/.test(e.target.innerHTML))){
				// check if the input contains only numbers
				e.target.innerHTML = this.lastValue;
				alert("Ce champ ne peut contenir que des chiffres");
				return;
			}
			this.lastValue = e.target.innerHTML;
			this.size = e.target.textContent.length;
			this.$forceUpdate();
		},
		onKeyEnter (e) {
			if(this.submit_on_enter_key) {
				e.preventDefault();
				this.change(e);
				e.target.blur();
			}
		}
	},
	mounted: function () {
		this.is_empty = (this.value == "");
		this.lastValue = this.value;
		this.size = this.value ? this.value.length : 0;
	}
};
</script>


<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

.align-justify {
	text-align justify
}

.display-area
	white-space pre-line

.el-textarea-wrapper
	position relative

	&.can-change.has-max-length
		margin-bottom 5px

.element.el-textarea
	display block
	overflow hidden
	&.error
		.stylisable-box
			box-shadow 0 0 0 2px #f00 !important
		.input
			box-shadow 0 0 0 1px #f00 !important
		.input:focus
			box-shadow 0 0 0 2px #fff, 0 0 0 4px #ff0000 !important
		*
			color #ff0000
			font-weight bold
	
	p.editable
		height calc(100% - 20px)

	.inline-placeholder
		opacity 0.4

		.printing &
			display none

	.placeholder
		position absolute
		z-index 1
		pointer-events none
		top 0
		left 8px
		bottom 0
		right 8px
		display flex
		align-items center
		justify-content center
		opacity 0.3
		line-height 14px
		font-size 11px
	.mask-hover
		position absolute
		left 0
		top 0
		right 0
		bottom 0
	.input
		min-width 8px
		height 100%
		//overflow scroll
		>>> strong
			font-weight 600
	> p
		display inline-block
	.stylisable-box
		position absolute
		right -92px
		top 50%
		transform translateY(-50%)
		height ((40px * 4) + (4px * 3) + 14px + 32px)
		width 72px
		padding 16px
		background-color #fff
		box-shadow 0 0 0 2px #ddd
		z-index 10001
		&:after
			content ''
			position absolute
			left -8px
			top calc(50% - 8px)
			width 0
			height 0
			border-style solid
			border-width 8px 8px 8px 0
			border-color transparent #ddd transparent transparent
		.stylisable-button
			display block
			width 40px
			height 40px
			margin 0 0 4px 0
			border none
			background #ddd
			border-radius radius
			font inherit
			font-size 16px
			color inherit
			text-transform uppercase
			cursor pointer
			&:last-child
				margin-bottom 0
			&.bold
				font-weight 600
			&.italic
				font-style italic
			&.underline
				text-decoration underline
			&:hover
				background-color purple
				color #fff
		hr
			border none
			width 50%
			border-bottom 2px solid #eee
			background none
			margin 8px auto


.counter
	position absolute
	font-size 12px
	bottom 0
	transform translateY(100%)
	line-height 1
</style>

<style lang="stylus">
.textarea-title:not(.can-change)
	display inline

	.el-textarea
		display inline

	p
		display inline
		text-decoration underline
</style>